import { z } from 'zod'
import { oc } from '@orpc/contract'

// Minimal case summary — proves the module wiring end-to-end. Statuses are the raw
// ledger codes (billing-v2-shared.ts value sets; plain strings here because contract
// files must stay browser-safe: zod + @orpc/contract imports only).
const caseSummarySchema = z.object({
  id: z.number(),
  claimStatus: z.string(),
  paymentStatus: z.string(),
  origin: z.string(),
  dos: z.string().nullable(),
})

export const billingV2CaseByEncounter = oc
  .route({ method: 'GET', path: '/v2/billing/case-by-encounter/{encounterId}' })
  .input(z.object({ encounterId: z.string() }))
  .output(z.object({ exists: z.boolean(), case: caseSummarySchema.optional() }))
